<script>
	const sizeType = {
		type: [String, Number],
		default: '100%'
	}
		
	export default {
		name: 'base-container',
		
		props: {
			/* 默认宽度（非响应式） */
			width: sizeType,
			
			/* 布局容器高度 */
			height: sizeType,
			
			/* 容器载体元素 */
			el: {
				type: String,
				default: 'DIV'
			},
			
			/* 容器横向对齐方式 */
			align: {
				type: String,
				default: 'left'
			},
			
			/* 容器纵向对齐方式 */
			valign: {
				type: String,
				default: 'top'
			}
		},
		
		computed: {
			realSize(){
				return this.sizeStyle(this.width, this.height)
			},

			/** 如果是非标准的HTML元素、则默认渲染为 DIV元素 **/
			className(){
				return [this.dir.toLowerCase() == 'vert' ? 'x-vert' : 'x-hori', this.align, this.valign].join('-')
			}
		},
		
		methods: {
			formatSize(size = ''){
				const reg = /\bauto\b|^\d*\.?\d+%?$/
				return (size && reg.test(size)) ? size : '100%'
			},

			/**
			 * feature: 在这里适配响应式布局、目前因为不清楚其他布局UI的视觉稿是以多少像素作为基准，所以暂不添加和响应式有关的设置
			 * @method
			 * @param w <String>
			 * @param h <String>
			 * @author Joey <54230107@qq.com>
			 * @createDate 2020/4/21
			 * @version 1.0.0
			 * @return <Object> size
			 **/
			sizeStyle(w, h){
				const
					width = this.formatSize(w),
					height = this.formatSize(h),
					size = Object.create(null),
					cols = Object.keys(this.$attrs).filter(colName => /col-(xs|sm|md|lg|xl)-\d{1,2}$/.test(colName))

				if(width && cols.length === 0){
					size.width = (/auto|%/.test(width) ? width : parseFloat(width / 75) + 'rem')
				}
				if(height){
					size.height = (/auto|%/.test(height) ? height : parseFloat(height / 75) + 'rem')
				}
				if(this.wrap){
					size.flexWrap = 'wrap'
				}
				return size
			},
			
			

			clickHandler(){
				this.$emit('click')
			},

			touchstart(){
				this.$emit('touchstart')
			},

			touchmove(){
				this.$emit('touchmove')
			}
		}
	}
	
	export function $$render(c){
		const cols = Object.keys(this.$attrs).filter(colName => /col-(xs|sm|md|lg|xl)-\d{1,2}$/.test(colName))
		return c(this.el, {
			class: ['x-ui', this.className, ...cols],
			style: this.realSize,
			on: {
				click: this.clickHandler,
				touchstart: this.touchstart,
				touchmove: this.touchmove
			}
		}, [this.$slots.default])
	}
</script>